import logoImage from "@/assets/aurora-logo.png";

interface AuroraLogoProps {
  className?: string;
  size?: number;
}

const AuroraLogo = ({ className = "", size = 24 }: AuroraLogoProps) => {
  return (
    <img
      src={logoImage}
      alt="Aurora Logo"
      width={size}
      height={size}
      loading="eager"
      decoding="sync"
      // @ts-ignore - fetchpriority is valid but not in React types yet
      fetchpriority="high"
      className={className}
      style={{ 
        objectFit: "contain",
        width: size,
        height: size,
      }}
    />
  );
};

export default AuroraLogo;